import React from 'react';

class LogoutInfo extends React.Component {

    render() {

        if(this.props.show) {
            return (
                <div className="logoutInfo">
                    <a href="/innsyn/signout">
                        <button className="buttonBlue float-md-right" type="button">logg ut</button>
                    </a>
                </div>
            )
        } else {
            return(
                <div/>
            );
        }
    }
}

export default LogoutInfo;

